/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { create } from 'zustand';

export interface SupportSession {
  grantId: string;
  orgId: string;
  orgName: string;
  accessLevel: 'READ_ONLY' | 'FULL_ACCESS';
  expiresAt: string;
}

interface SupportSessionState {
  activeSession: SupportSession | null;
  enterSession: (session: SupportSession) => void;
  exitSession: () => void;
}

export const useSupportSessionStore = create<SupportSessionState>((set) => {
  // Restore from sessionStorage on init
  let initial: SupportSession | null = null;
  try {
    const stored = sessionStorage.getItem('corex-support-session');
    if (stored) {
      const parsed = JSON.parse(stored) as SupportSession;
      // Check if expired
      if (new Date(parsed.expiresAt).getTime() > Date.now()) {
        initial = parsed;
      } else {
        sessionStorage.removeItem('corex-support-session');
      }
    }
  } catch {
    // Ignore parse errors
  }

  return {
    activeSession: initial,

    enterSession: (session) => {
      sessionStorage.setItem('corex-support-session', JSON.stringify(session));
      set({ activeSession: session });
    },

    exitSession: () => {
      sessionStorage.removeItem('corex-support-session');
      set({ activeSession: null });
    },
  };
});
